import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.css";
import React, { Suspense } from "react";
import { HashRouter, Redirect, Switch } from "react-router-dom";
import "./App.css";
import Loading from "./components/Loading";
import PrivateRoute from "./components/PrivateRoute";
// import background from './assets/image/BGR-02.png';

const Flashscreen = React.lazy(() => import("./containers/Flashscreen"));
const Menu = React.lazy(() => import("./containers/Menu"));
const Predict = React.lazy(() => import("./containers/Predict"));
const Term = React.lazy(() => import("./containers/Term"));
const Guide = React.lazy(() => import("./containers/Guide"));
const Schedules = React.lazy(() => import("./containers/Schedule/Schedules"));
const ScheduleDetail = React.lazy(() =>
  import("./containers/Schedule/ScheduleDetail")
);
const PredictHistory = React.lazy(() =>
  import("./containers/History/PredictHistory")
);
const HistoryDetail = React.lazy(() =>
  import("./containers/History/HistoryDetail")
);
const ChampionTeam = React.lazy(() =>
  import("./containers/Predict/ChampionTeam")
);
const Page404 = React.lazy(() => import("./components/Page404"));

const App = () => {
  return (
    <HashRouter>
      <div className="app-container container-fluid">
        <div className="row">
          {/* <img
            src={BACKGROUND}
            style={{
              position: "fixed",
              top: "0px",
              width: "100%",
              zIndex: "-1",
              height: "100vh",
              objectFit: "contain",
            }}
            alt="wc-background"
          /> */}
          <div className="app w-100">
            <Suspense fallback={<Loading />}>
              <Switch>
                <Redirect exact from="/" to="/flashscreen" />
                <PrivateRoute exact path="/flashscreen">
                  {() => <Flashscreen />}
                </PrivateRoute>
                <PrivateRoute path="/predict">{() => <Predict />}</PrivateRoute>
                <PrivateRoute exact path="/menu">
                  {() => <Menu />}
                </PrivateRoute>
                <PrivateRoute exact path="/term">
                  {() => <Term />}
                </PrivateRoute>
                <PrivateRoute exact path="/guide">
                  {() => <Guide />}
                </PrivateRoute>
                <PrivateRoute exact path="/schedule">
                  {() => <Schedules />}
                </PrivateRoute>
                <PrivateRoute exact path="/schedule/:id">
                  {() => <ScheduleDetail />}
                </PrivateRoute>
                <PrivateRoute exact path="/predict-history">
                  {() => <PredictHistory />}
                </PrivateRoute>
                <PrivateRoute exact path="/hisoty-detail">
                  {() => <HistoryDetail />}
                </PrivateRoute>
                <PrivateRoute exact path="/champion-team">
                  {() => <ChampionTeam />}
                </PrivateRoute>
                <PrivateRoute path="*">{() => <Page404 />}</PrivateRoute>
              </Switch>
            </Suspense>
            {/* <ButtonBack /> */}
          </div>
        </div>
      </div>
    </HashRouter>
  );
};

export default App;
